<template>
  <div class="generator-review card p-4 mb-3">
    <!-- Basic Information -->
    <h4>{{ $t("signup.se.generator_review.basic_information") }}</h4>

    <TextFieldComponent
      v-model="goApplication.grid_owner_name"
      field="signup.se.generator_review.grid_owner_name"
      :rules="requiredRules"
    />
    <TextFieldComponent
      v-model="goApplication.grid_owner_corporate_id"
      field="signup.se.generator_review.grid_owner_corporate_id"
      :rules="requiredRules"
    />
  </div>
</template>

<script setup lang="ts">
import { useValidators } from "@/composables/useValidators";
import TextFieldComponent from "@/signup/common/TextFieldComponent.vue";
import type { Account, Generator } from "@/types";
import { computed, reactive, watch } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  generatorIndex: number;
  companyIndex: number;
  accountData: Account;
}>();

const emit = defineEmits<{
  handleUpdateGenerator: [generator: Generator];
}>();

const { t } = useI18n();
const { required } = useValidators(t);
const requiredRules = { required };

const generator = computed(
  () =>
    props.accountData.companies[props.companyIndex].generators[
      props.generatorIndex
    ]
);

// Initialize with default values
const localGenerator = reactive({
  ...generator.value,
  application_information: {
    ...generator.value.application_information,
    go_application: {
      ...generator.value.application_information?.go_application,
      grid_owner_address: {
        ...generator.value.application_information?.go_application
          ?.grid_owner_address,
      },
    },
  },
});

const goApplication = computed(
  () => localGenerator.application_information.go_application
);

watch(
  localGenerator,
  (newValue) => {
    emit("handleUpdateGenerator", newValue);
  },
  { deep: true }
);
</script>

<style scoped lang="scss">
.generator-review {
  h4 {
    margin-bottom: 1rem;
  }
}

@media (max-width: 575.98px) {
  h4 {
    font-size: 1.2rem;
  }
}
</style>
